import { Account, Group } from '../App';

export type AnnotationSearchParams = Account | Group;

function isAccount(value: AnnotationSearchParams): value is Account {
    return Object.hasOwn(value, "account");
}

function isGroup(value: AnnotationSearchParams): value is Group {
    return Object.hasOwn(value, "groupId");
}

export async function hGetAnnotations(setAnnotations: (value: React.SetStateAction<any[]>) => void, params: AnnotationSearchParams, setErrorMessage: React.Dispatch<React.SetStateAction<string>>) {

    try {
        const requestInit: RequestInit = {};
        let url = new URL(`https://api.hypothes.is/api/search`);
        if (isAccount(params)) {
            url.searchParams.set(`user`, `acct:${params.account}`);
        }

        if (isGroup(params)) {
            url.searchParams.set(`group`, params.groupId);
            requestInit.headers = {
                "Authorization": `Bearer ${params.apiToken}`,
            };
        }

        if (params.searchAfter) {
            url.searchParams.set('sort', 'created');
            url.searchParams.set('search_after', encodeURIComponent(params.searchAfter));
            // url.searchParams.set('search_after', encodeURIComponent(
            //     "2023-06-17T00:00:00.000000+00:00"
            // ));
            // url.searchParams.set('search_after', encodeURIComponent(
            //     new Date().valueOf().toString()
            // ));
        }

        url.searchParams.set('limit', '200');
        url.searchParams.set('order', 'asc');

        const response = await fetch(url.toString(), requestInit);
        const data = await response.json();
        setAnnotations(a => {
            return data.rows;
        });

        if (!data?.rows?.length) {
            setErrorMessage("No Annotations Found. You may want to check your API token.");
        }
    } catch (e) {
        setErrorMessage("error:" + (e as Error).message);
    }
}
